<section class="fina-phase-detail" *ngIf="!isLoading && phase">
    <div class="fina-phase-detail__hero">
        <button type="button" class="fina-phase-detail__close" aria-label="Cerrar" (click)="activeModal.dismiss('close')">
            <fa-icon [icon]="['fas', 'xmark']"></fa-icon>
        </button>

        <h2>Tu configuración en Fina</h2>
        <p>Completa las tareas y descubre todo lo que Fina puede hacer por tu negocio.</p>

        <div class="fina-phase-detail__progress-card">
            <div class="fina-phase-detail__progress-copy">
                <strong>{{ completedTasks }} de {{ tasks.length }} tareas completadas</strong>
                <span>{{ completionPercent }}%</span>
            </div>
            <div class="fina-phase-detail__progress-track">
                <span [style.width.%]="completionPercent"></span>
            </div>
        </div>
    </div>

    <div class="fina-phase-detail__body">
        <!-- Las pestañas Obligatorias/Opcionales (y su texto explicativo) solo se muestran si la fase tiene
             AMBOS tipos de tareas. Fase 1 (solo obligatorias) y Fase 3 (solo opcionales) → se ocultan; la lista
             de tareas se lista directamente debajo (evita el confuso "Obligatorias 0/0"). -->
        <div class="fina-phase-detail__tabs" *ngIf="showTabs">
            <button type="button" [class.active]="activeTab === 'mandatory'" (click)="setTab('mandatory')">
                <span>Obligatorias</span>
                <strong>{{ mandatoryCompleted }}/{{ mandatoryTasks.length }}</strong>
            </button>
            <button type="button" [class.active]="activeTab === 'optional'" [disabled]="!optionalTasks.length" (click)="setTab('optional')">
                <span>Opcionales</span>
                <strong>{{ optionalCompleted }}/{{ optionalTasks.length }}</strong>
            </button>
        </div>

        <p class="fina-phase-detail__hint" *ngIf="showTabs && activeTab === 'mandatory' && !allMandatoryCompleted">
            Estas tareas son la base para que Fina te muestre números reales. Te recomendamos completarlas primero.
        </p>

        <div class="fina-phase-detail__tasks">
            <article class="fina-phase-detail__task" *ngFor="let task of visibleTasks" [class.completed]="task.isCompleted">
                <div class="fina-phase-detail__task-icon">
                    <fa-icon *ngIf="!task.isCompleted" [icon]="['fas', 'file-lines']"></fa-icon>
                    <fa-icon *ngIf="task.isCompleted" [icon]="['fas', 'check']"></fa-icon>
                </div>

                <div class="fina-phase-detail__task-content">
                    <div class="fina-phase-detail__task-heading">
                        <h3>{{ task.title }}</h3>
                        <span [class.completed]="task.isCompleted">{{ task.isCompleted ? 'Completada' : 'Pendiente' }}</span>
                    </div>
                    <p>{{ task.description || 'Completa esta tarea para avanzar en la configuración de tu negocio.' }}</p>
                </div>

                <button *ngIf="!task.isCompleted" type="button" class="fina-phase-detail__start" (click)="startTask(task)">Empezar</button>
            </article>
        </div>
    </div>
</section>

<section class="fina-phase-detail fina-phase-detail--empty" *ngIf="!isLoading && !phase">
    <button type="button" class="fina-phase-detail__close" aria-label="Cerrar" (click)="activeModal.dismiss('close')">
        <fa-icon [icon]="['fas', 'xmark']"></fa-icon>
    </button>
    <h2>Tu configuración en Fina</h2>
    <p>No pudimos cargar tus tareas de onboarding en este momento.</p>
</section>
